import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {StandaloneFormComponent} from "../../../../../umbrella-common/components/standalone-form.component";
import {Order} from "../../../../../store/state/order.state";
import {BillingPreferencesFomService} from "./billing-preferences-fom.service";
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'billing-preferences',
    templateUrl: './billing-preferences.template.html',
    styleUrls: ['./billing-preferences.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BillingPreferencesComponent extends StandaloneFormComponent implements OnInit {

	@Input() order: Order;
	form: FormGroup;

	constructor(public formService: BillingPreferencesFomService) { // public - AOT issue fix
		super(formService);
	}

	ngOnInit(): void {
		this.form = this.formService.buildStandaloneForm(this.order.billingInformations);
	}

	updatePaymentRequired(required: boolean) {
		this.formService.updatePaymentRequired(required);
	}

	shouldDisableRadio(controlName: string): boolean {
		return this.getFormControl(controlName).disabled;
	}
}
